import { Typography, TypographyProps } from '@eventbrite/marmalade';
import React from 'react';

interface EventCardTitleProps extends Omit<TypographyProps, 'children'> {
    title: string;
}

/**
 * Migrated from eb-ui on 2024/12/12. [4ca86ae](https://github.com/eventbrite/eb-ui/tree/4ca86ae8527e025600175b5132e73a15b579ac46/packages/attendee/event-renderer/src/components/EventCardTitle)
 */
export const EventCardTitle = (props: EventCardTitleProps) => {
    const { title, ...typographyProps } = props;

    return (
        <Typography variant="body-lg" as="h3" {...typographyProps}>
            {title}
        </Typography>
    );
};
